import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import {
  DatePicker, Form, Radio, Select,
} from 'antd';
import { getPaciente } from '../../../state/actions/creators/pacientes.actioncreator';
import { getPrescriptores } from '../../../state/actions/creators/fichaOptometrica.actioncreator';
import {
  getDatosFichaContactologica,
  getDatosUltimaOptometria,
} from '../../../state/actions/creators/fichaContactologica.actioncreator';
import Page from '../../shared/components/layout/Page.layout';
import { Box, Flex, Text } from '../../shared/components';
import LoadingWorkspaceSkeleton from '../../encargos/components/dataDisplay/LoadingWorkspaceSkeleton.datadisplay';
import { FichaContactologicaFormulario } from './fichaContactologica.form';
import ShowIf from '../../shared/components/dataDisplay/ShowIf';
import ReadOnly from '../../shared/components/dataEntry/ReadOnly';

export function FichaContactologicaFormHeader({
  watch,
  create,
  form,
  onSetValue,
  datosGraduacion,
  setDrawerPrescriber,
  setDrawerAttended,
}) {
  const params = useParams();
  const dispatch = useDispatch();
  const { pacienteId, codigo } = params;
  const tiendaId = useSelector(state => state.auth.user.user_info.tienda_id);
  const prescriptores = useSelector(state => state.fichaOptometricaWorkspace.prescriptores);
  const paciente = useSelector(state => state.pacientesWorkspace.pacienteSelected);
  const tiendas = useSelector(state => state.core.tiendas);
  const sagas = useSelector(state => state.sagas);
  const nextGrad = useSelector(state => state.auth.permisos.configuracion.prox_gradcontac);
  const tiendaCreate = create ? tiendas.find(e => e.id === tiendaId) : null;
  const tiendaCreateName = create && tiendaCreate ? tiendaCreate.nombre : null;
  const { getFieldDecorator } = form;

  useEffect(() => {
  }, []);

  const configAtendidoPor = {
    rules: [{ required: true, message: 'Es necesario el atendido por' }],
    initialValue: datosGraduacion && datosGraduacion.atendido_por_nombre,
  };
  const configPrescriptor = {
    rules: [{ required: true, message: 'Es necesario el prescriptor' }],
    initialValue: datosGraduacion && datosGraduacion.prescriptor_nombre,
  };
  const configFecha = {
    rules: [{ required: true, message: 'La fecha es obligatoria' }],
    initialValue: (datosGraduacion && datosGraduacion.fecha && moment(datosGraduacion.fecha, 'DD/MM/YYYY hh:mm:ss') || moment()),
  };
  const configFechaProx = {
    initialValue: (datosGraduacion && datosGraduacion.fecha_proxima_graduacion && moment(datosGraduacion.fecha_proxima_graduacion, 'DD/MM/YYYY hh:mm:ss')),
  };
  return (
    <>
      <Text fontFamily="Open Sans" color="#3E3E3C" fontWeight="600" fontSize="16px" translationId="ficha_contactologica.datosGraduacion" />
      <Flex fontFamily="Open Sans" mt="16px" style={{ flexWrap: 'wrap' }} alignItems="baseline">
        <ShowIf condition={!create}>
          <Flex flexDirection="column" flex="1">
            <Text fontSize="16px" color="#706E6B" lineHeight="22px" width="50%" translationId="ficha_contactologica.codigo" />
            <Text fontSize="16px" color="#3E3E3C" width="50%">{datosGraduacion && datosGraduacion.codigo}</Text>
          </Flex>
        </ShowIf>
        <Flex flexDirection="column" flex="1">
          <Flex flexDirection="column" ml={create ? 0 : '16px'}>
            <Text fontSize="16px" color="#706E6B" lineHeight="22px" translationId="ficha_contactologica.tienda" />
            <Text fontSize="16px" color="#3E3E3C">
              {datosGraduacion ? datosGraduacion.nombre_tienda : tiendaCreateName}
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex mt="16px">
        <Flex flexDirection="column" flex="2">
          <Text mb="8px" width="50%" fontSize="16px" font color="#706E6B" translationId="ficha_contactologica.tipo_ficha" />
          <Radio.Group size="large" disabled={watch || !create && datosGraduacion && datosGraduacion.tipo_ficha === 'D'} onChange={e => onSetValue({ tipo_ficha: e.target.value }, {})} value={datosGraduacion && datosGraduacion.tipo_ficha ? datosGraduacion.tipo_ficha : 'P'}>
            <Radio.Button value="P" style={{ width: '50%' }}>
              <Text
                fontSize="16px"
                width="100%"
                textAlign="center"
                translationId="ficha_contactologica.prueba"
              />
            </Radio.Button>
            <Radio.Button value="D" style={{ width: '50%' }}>
              <Text
                fontSize="16px"
                width="100%"
                textAlign="center"
                translationId="ficha_contactologica.definitivo"
              />
            </Radio.Button>
          </Radio.Group>
        </Flex>
        <Flex flexDirection="column" flex="1" minWidth="170px">
          <Box ml="16px">

            <Text mb="8px" width="25%" fontSize="16px" font color="#706E6B" translationId="ficha_contactologica.fecha" />
            <ReadOnly condition={watch}>
              <Form.Item>
                {getFieldDecorator('fecha', configFecha)(
                  <DatePicker
                    style={{ minWidth: '144px' }}
                    disabled={watch}
                    size="large"
                    format="DD/MM/YYYY"
                    onChange={(date) => {
                    // setFieldsValue({ fecha: date });
                      onSetValue({ fecha: date.format('DD/MM/YYYY') }, {});
                    }}
                  />,
                )}
              </Form.Item>
            </ReadOnly>
          </Box>
        </Flex>
        <Flex flexDirection="column" flex="1" minWidth="170px">
          <Box ml="16px">
            <Text mb="8px" fontSize="16px" font color="#706E6B" translationId="ficha_contactologica.proxima_graduacion" />
            <ReadOnly condition={watch}>
              <Form.Item>
                {getFieldDecorator('fecha_proxima_graduacion', configFechaProx)(
                  <DatePicker 
                  style={{ minWidth: '144px' }} 
                  disabled={watch} 
                  size="large" 
                  format="DD/MM/YYYY"
                  value={datosGraduacion && datosGraduacion.fecha_proxima_graduacion && moment(datosGraduacion.fecha_proxima_graduacion).format('DD-MM-YYYY')} 
                  onChange={date => {
                    onSetValue({ fecha_proxima_graduacion: date.format('DD/MM/YYYY hh:mm:ss') }, {})
                  }}
                  />
                )}  
              </Form.Item>  
            </ReadOnly>
          </Box>
        </Flex>
      </Flex>
      <Flex mt="16px" style={{ flexWrap: 'wrap' }}>
        <Flex flexDirection="column" flex="1">
          <Text mb="8px" width="50%" fontSize="16px" font color="#706E6B" translationId="ficha_contactologica.atendido_por" />
          <ReadOnly condition={watch}>
            <Form.Item>
              {getFieldDecorator('atendido_por', configAtendidoPor)(
                <Select disabled={watch} dropdownClassName="ant-select-dropdown-hidden" size="large" style={{ width: '100%', minWidth: '185px' }} onDropdownVisibleChange={() => watch || setDrawerAttended(true)} />,
              )}
            </Form.Item>
          </ReadOnly>
        </Flex>
        <Flex flexDirection="column" flex="1">
          <Box ml="16px">
            <Text mb="8px" fontSize="16px" font color="#706E6B" translationId="ficha_contactologica.prescriptor" />
            <ReadOnly condition={watch}>
              <Form.Item>
                {getFieldDecorator('prescriptor', configPrescriptor)(
                  <Select disabled={watch} dropdownClassName="ant-select-dropdown-hidden" size="large" style={{ width: '100%', minWidth: '185px' }} onDropdownVisibleChange={() => watch || setDrawerPrescriber(true)} />,
                )}
              </Form.Item>
            </ReadOnly>
          </Box>
        </Flex>
      </Flex>
    </>
  );
}
